
import TableList from "@components/templates/tablelist";
import { HttpGetbillPeriodList, HttpSavebillPeriodOne, HttpClsebillPeriodOne } from "@/service/newbigaccount";
import comIndex from './update'
import { mapGetters } from "vuex";
export default {
    mixins: [TableList],
    components: {
        comIndex,
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                search: {
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true }
        };
    },
    methods: {
        ajaxRequest: HttpGetbillPeriodList,
        handleOperates(params = "", type, batch) {

            switch (type) {
                case "query":
                    this.operate = {
                        title: '查看',
                        show:true,
                        width:1200,
                        component: "comIndex",
                        activeid:params,
                        querytype:'query',
                        showFooter:false
                    }
                    break;
                case "edit":
                    this.$router.push({
                        name: 'bigaccountPaymentdayDetail',
                        params: { type: "edit" },
                        query: { id: params },
                    });
                    break;
                case "add":
                    this.operate = {
                        show: true,
                        alert: "primary",
                        title: "添加账期",
                        showDesc:false,
                        width: 650,
                        formdata: [
                            {
                                tag:'vSelect',
                                key:'organizationId',
                                label:'组织',
                                span: 24,
                                options:this.getBillcusorgList,
                                props:{
                                    filterable:true,
                                    clearable:true,
                                }
                            },
                            {
                                tag: "vInput",
                                key: "code",
                                span: 24,
                                label: "账期描述",
                            },
                            {
                                tag: "vDatepicker",
                                key: "startTime",
                                span: 12,
                                label: "开始时间",
                                props:{
                                    format:'yy-mm-dd',
                                    confirm:false,
                                },
                            },
                            {
                                tag: "vDatepicker",
                                key: "endTime",
                                span: 12,
                                label: "结束时间",
                                props:{
                                    format:'yy-mm-dd',
                                    confirm:false,
                                },
                            },

                        ],
                        ajaxRequest:HttpSavebillPeriodOne
                    };
                break;
                case "delete":
                    this.operate = {
                        show: true,
                        alert: "error",
                        title: "关闭账单",
                        desc:'关闭账期后不可恢复，且费用不可结算在该账期内，是否确认关闭？',
                        width: 460,
                        params:{id:params},
                        // formdata: [
                        //     {
                        //         tag: "vTextarea",
                        //         key: "remark",
                        //         span: 24,
                        //         label: "备注原因",
                        //         required:false,
                        //     }
                        // ],
                        ajaxRequest:HttpClsebillPeriodOne
                    };
                    break;
                case 'importExcel':
                    this.operate = {
                        show: true,
                        title: '导入数据',
                        width: 460,
                        showFooter: false,
                        action: process.env.VUE_APP_APIURL_FBB+ "/api/v2/newBilling/billPeriod/import",
                        name: "file",
                        component: "compUpload",
                        download: () => {
                            // this.handleWebfs("/static/template/paymentday.xlsx", {}, {
                            //     executor: 'download',
                            //     type: 'url'
                            // });
                            this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/newBilling/billPeriod/downloadTemplate", {}, 'download')
                        },
                        on:{
                            "on-success":()=>{
                                this.$emit('on-close')
                            }
                        }
                    };
                    break;
            }
        },
        getOperateNodeMap(row){
            const { id } = row
            return [
                {
                    label:'查看',
                    show:true,
                    params:id,
                    operate:'query'
                },{
                    label:'编辑',
                    show: true,
                    params:id,
                    operate:'edit'
                },
                // {
                //     label:'关闭账期',
                //     show: true,
                //     params:id,
                //     operate:'delete'
                // },
            ]
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getBillcusorgList', 'getCusBillTypeList']),
        ToolsData() {
            return [
                {
                    name: '添加',
                    operate: "add",
                    theme: "primary",
                    // batch: true,
                },
                {
                    name: '导入',
                    operate: "importExcel",
                    theme: "success",
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: "组织",
                    tag: 'vSelect',
                    key: 'EQ_organizationId',
                    show:true,
                    options:this.getBillcusorgList,
                    props:{
                        filterable:true,
                    }
                },
                {
                    label: '账期描述',
                    tag: 'vInput',
                    key: 'CN_code',
                    show: true,
                },
                // {
                //     label: "状态",
                //     tag: 'vSelect',
                //     key: 'EQ_status',
                //     show:true,
                //     options:[
                //         {value:0,label:'未关账'},
                //         {value:1,label:'已关账'},
                //     ],
                //     props:{
                //         filterable:true,
                //     }
                // },
                {
                    label: '开始日期',
                    tag: 'vDatepicker',
                    key: 'GE_startTime',
                    style: "width:180px",
                    props:{
                        format:'yy-mm-dd',
                        confirm:false,
                    },
                },
                {
                    label: '结束日期',
                    tag: 'vDatepicker',
                    key: 'LE_endTime',
                    style: "width:180px",
                    props:{
                        format:'yy-mm-dd',
                        confirm:false,
                    },
                },
            ]
        },
        columns() {
            return [
                {
                    title: '操作',
                    width: 90,
                    render:this.getOperateNodes,
                },
                {
                    title: '组织',
                    key: 'organizationName',
                },
                {
                    title: '账期描述',
                    key: 'code',
                },
                // {
                //     title: '状态',
                //     key: 'status',
                //     render:(h,{row})=>{
                //         return <div>{row.status === 1 ? '已关账' : '未关账'}</div>
                //     }
                // },
                {
                    title: '开始日期',
                    key: 'startTime',
                },
                {
                    title: '结束日期',
                    key: 'endTime',
                },
            ];
        },

    },

};
